<mat-card>
  <form name="venueForm" [formGroup]="form">
    <h3>Where is this event on?</h3>
    <p>All the the fields provided below are mandatory.</p>
    <div class="row">
      <div class="col-md-6 col-sm-12" *ngIf="showVenueName">
        <mat-form-field appearance="outline">
          <input matInput required formControlName="name" name="venue_name" aria-label="Location Name"
            (focusout)="trimValue($event,'name')">
          <mat-label>Name</mat-label>
          <mat-hint>The location name of the event.</mat-hint>
          <mat-error *ngIf="form.get('name').invalid">{{getErrorMessage('name')}}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" style="margin-top: 15px;">
        <mat-form-field class="full-width" [appearance]="appearance">
          <mat-label *ngIf="addressLabelText !== '' || addressLabelText">{{addressLabelText}}</mat-label>
          <input matInput formControlName="address" placeholder="{{placeholderText}}"
            class="form-control" #search MatValidateAddress required>
          <mat-error *ngIf="form.get('address').invalid">{{getErrorMessage('address')}}</mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-12" style="margin-bottom: 30px;" *ngIf="mapsLoaded">
        <google-map
          [center]="{lat: latitude, lng: longitude}"
          [zoom]="12"
          [options]="{scrollwheel: false, streetViewControl: false}"
          width="100%"
          height="350px">
          <map-marker [position]="{lat: latitude, lng: longitude}"></map-marker>
        </google-map>
      </div>
      <div class="col-md-12">
        <input type="hidden" formControlName="googleplaceid" name="googleplaceid">
      </div>
    </div>
  </form>
</mat-card>